//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
export default {
  name: 'episodeItem',
  mixins: [ImageSrcsetMixin],
  props: ['resource', 'index', 'show', 'minimal', 'ratio', 'type', 'thumb', 'playbutton'],
  computed: {
    ...mapState({
      episode: ({ resourcesStore: {episode} }) => episode,
    }),
  },
}
